// Raw colour scale. No semantics here: every value is a hue step, named by hue and lightness.
// Only paletteDark.ts, paletteLight.ts and payment.ts read it; screens use theme.palette.* tokens.
export const primitives = {
  white: '#FFFFFF',
  black: '#000000',
  ink: '#0F0F0F',
  navy: {
    900: '#151821',
    800: '#212535',
    700: '#2A2E3C',
    600: '#3E4473',
    500: '#4E5159',
  },
  cream: {
    50: '#FFFFEF',
    100: '#F4F4E6',
    200: '#E3E3D3',
    400: '#B1B1AC',
  },
  // Cool tints of the dark theme's outlines and focus ring.
  mist: {
    100: '#EAEEF7',
  },
  periwinkle: {
    400: '#7A81FF',
  },
  slate: {
    300: '#ACB2BC',
    500: '#7E7E88',
  },
  gray: {
    50: '#FAFAFA',
    100: '#F7F7F7',
    300: '#CDCDCD',
    400: '#C2C2C2',
    700: '#4F4F4F',
  },
  blue: {
    400: '#6378FD',
    300: '#A2B9FF',
  },
  cyan: {
    300: '#5CCEFF',
    400: '#1CE9FC',
  },
  yellow: {
    400: '#FFC60A',
    300: '#FFDD6F',
  },
  green: {
    500: '#27AE60',
    400: '#4DAB75',
    300: '#54D993',
  },
  red: {
    500: '#E13F3D',
  },
  mint: {
    300: '#2AFFCC',
  },
  lavender: {
    50: '#F6F4FE',
    100: '#EDEAFB',
    200: '#E8E8FC',
    300: '#B1B1CE',
    400: '#8E8CF0',
  },
  violet: {
    600: '#4931FF',
  },
  // Warm monetisation accents of the light theme: upsell ribbon, promo label, special-offer border.
  orange: {
    300: '#FFAC33',
    400: '#E78E00',
    500: '#DC7D00',
  },
  // Payment-form hues below: the Solid card-form submit button, the legal-text links and
  // PayPal's brand gold (fixed by PayPal's guidelines, never A/B-variable).
  lime: {
    500: '#69B13F',
  },
  sky: {
    300: '#61B3FF',
  },
  amber: {
    400: '#FFC439',
    500: '#F3BA37',
  },
} as const;
